export default class Product {
  from_api_to_grid = (data) =>
    data.map((item) => ({
      ...item,
      description: item.description || "",
    }));

  from_form_to_api = ({
    promotional_price,
    variants,
    price,
    code,
    shared_stock_available,
    shared_stock_total,
    ...data
  }) => {
    const stock_management_level = data.stock_management_level || "SKU";

    return {
      ...data,
      stock_management_level,
      characteristics: data.characteristics.filter(
        (characteristic) =>
          characteristic.characteristic_type_id && characteristic.value,
      ),
      skus: data.skus
        .filter((sku) => sku.active)
        .map(({ active, ...sku }) => ({
          ...sku,
          characteristics: sku.characteristics.map((characteristic) => ({
            characteristic_type_id: characteristic.characteristic_type_id,
            value: characteristic.value_label,
          })),
          money: sku.money.map((item_money) => ({
            ...item_money,
            promotional_price: item_money.promotional_price
              ? parseFloat(item_money.promotional_price)
              : null,
            price: item_money.price ? parseFloat(item_money.price) : 0,
          })),
          stock_available: parseInt(
            stock_management_level === "PRODUCT"
              ? shared_stock_available
              : sku.stock_available,
          ),
          stock_total: parseInt(
            stock_management_level === "PRODUCT"
              ? shared_stock_total
              : sku.stock_total,
          ),
        })),
    };
  };

  from_api_to_form = (data) => ({
    name: data.name,
    stock_management_level: data.stock_management_level || "SKU",
    shared_stock_available:
      data.stock_management_level === "PRODUCT"
        ? data.pms?.[0]?.stock_available || 0
        : 0,
    shared_stock_total:
      data.stock_management_level === "PRODUCT"
        ? data.pms?.[0]?.stock_total || 0
        : 0,
    code: (() => {
      const firstSkuCode = data.pms?.[0]?.code || "";
      const match = firstSkuCode.match(/^(.*?)\d+$/);
      return match ? match[1] : firstSkuCode;
    })(),
    description: data.description,
    promotional_price: (() => {
      const prices = data.pms
        ?.map((sku) => sku?.money?.[0]?.promotional_price)
        .filter((p) => p !== undefined && p !== null && !isNaN(p));
      return prices && prices.length ? Math.min(...prices) : "";
    })(),
    price: (() => {
      const prices = data.pms
        ?.map((sku) => sku?.money?.[0]?.price)
        .filter((p) => p !== undefined && p !== null && !isNaN(p));
      return prices && prices.length ? Math.min(...prices) : "";
    })(),
    category_id: data.category.id,
    characteristics: data.product_variant_option.map((characteristic) => ({
      characteristic_type_id:
        characteristic.characteristic_value.characteristic_type.id,
      value: characteristic.characteristic_value.value,
    })),
    variants: data.pms
      .flatMap((sku) => sku?.sku_variant_option)
      .reduce((group, iteration) => {
        const findId = group.findIndex(
          (item) =>
            item.characteristic_type_id ===
            iteration.characteristic_value.characteristic_type.id
        );
        if (findId > -1) {
          group[findId] = {
            characteristic_type_id: group[findId].characteristic_type_id,
            value: [
              ...new Set([
                ...group[findId].value,
                iteration.characteristic_value.id,
              ]),
            ],
          };

          return group;
        } else {
          return [
            ...group,
            {
              characteristic_type_id:
                iteration.characteristic_value.characteristic_type.id,
              value: [iteration.characteristic_value.id],
            },
          ];
        }
      }, []),
    skus: data.pms.map((sku) => ({
      id: sku.id,
      code: sku.code,
      active: true,
      description: sku.description,
      characteristics: sku.sku_variant_option.map((characteristic) => ({
        characteristic_type_id:
          characteristic.characteristic_value.characteristic_type.id,
        value: characteristic.characteristic_value.id,
        value_label: characteristic.characteristic_value.value,
      })),
      money: sku.money?.map((item) => ({
        price: parseFloat(item.price),
        promotional_price: parseFloat(item.promotional_price) || "",
        percent: item.percent,
        tax: item.tax,
        currency_code: item.currency_code,
      })),
      stock_available: sku.stock_available,
      stock_total: sku.stock_total,
    })),
  });
}
